import type { QuoteSignature } from './api'

const signedTime = new Intl.DateTimeFormat('en-US', { dateStyle: 'medium', timeStyle: 'short' })

/** Who signed a final quote, when, where and on what (USA-1285). */
export function SignatureDetails({ signature, quoteNumber }: { signature: QuoteSignature; quoteNumber?: string }) {
  const facts: [string, string][] = [
    ['Signed by', signature.signer_name],
    ['Signed', signedTime.format(new Date(signature.signed_at))],
    [
      'Document',
      `${quoteNumber ? `Quote ${quoteNumber} · ` : ''}Publication ${signature.publication_number} · revision ${signature.source_revision}`,
    ],
    ['Location', signature.location ?? 'Not available'],
    ['Device', signature.device],
    ['IP address', signature.ip_address],
  ]
  return (
    <dl className="grid grid-cols-[max-content_minmax(0,1fr)] gap-x-4 gap-y-1 text-xs">
      {facts.map(([label, value]) => (
        <div className="contents" key={label}>
          <dt className="text-muted-foreground">{label}</dt>
          <dd className="break-words" title={label === 'Device' ? signature.user_agent : undefined}>
            {value}
          </dd>
        </div>
      ))}
    </dl>
  )
}
